import { THistoricalDatesInPeriod } from './types/historicalDates'

export const historicalDates: THistoricalDatesInPeriod[] = [
    {
        period: [1980, 1986],
        section: 'Технологии',
        dates: [
            {
                year: 1980,
                description: 'Запуск первого персонального компьютера IBM PC'
            },
            {
                year: 1981,
                description: 'Создание первого ноутбука Osborne 1'
            },
            {
                year: 1982,
                description: 'Появление CD-ROM дисков'
            },
            {
                year: 1983,
                description: 'Создание первого мобильного телефона Motorola DynaTAC'
            },
            {
                year: 1984,
                description: 'Презентация первого Macintosh от Apple'
            },
            {
                year: 1985,
                description: 'Создание первой версии Windows 1.0'
            },
            {
                year: 1986,
                description: 'Запуск первого спутника GPS'
            }
        ]
    },
    {
        period: [1987, 1991],
        section: 'Кино',
        dates: [
            {
                year: 1987,
                description: 'Премьера фильма "Робокоп"'
            },
            {
                year: 1988,
                description: 'Выход фильма "Кто подставил кролика Роджера"'
            },
            {
                year: 1989,
                description: 'Премьера "Назад в будущее 2"'
            },
            {
                year: 1990,
                description: 'Выход фильма "Призрак" с Патриком Суэйзи'
            },
            {
                year: 1991,
                description: 'Премьера "Терминатор 2: Судный день"'
            }
        ]
    },
    {
        period: [1992, 1997],
        section: 'Литература',
        dates: [
            {
                year: 1992,
                description: 'Публикация романа "Алхимик" Пауло Коэльо'
            },
            {
                year: 1993,
                description: 'Выход книги "Парк Юрского периода" Майкла Крайтона'
            },
            {
                year: 1994,
                description: 'Публикация "Форрест Гамп" Уинстона Грума'
            },
            {
                year: 1995,
                description: 'Выход романа "Ангелы и демоны" Дэна Брауна'
            },
            {
                year: 1996,
                description: 'Публикация "Гарри Поттер и философский камень"'
            },
            {
                year: 1997,
                description: 'Выход романа "Код да Винчи" Дэна Брауна'
            }
        ]
    },
    {
        period: [1999, 2004],
        dates: [
            {
                year: 1999,
                description: 'Премьера мюзикла "Мама Миа!" в Лондоне'
            },
            {
                year: 2000,
                description: 'Открытие театра "Новая сцена" в Москве'
            },
            {
                year: 2001,
                description: 'Премьера мюзикла "Продюсеры" на Бродвее'
            },
            {
                year: 2002,
                description: 'Выход фильма-мюзикла "Чикаго"'
            },
            {
                year: 2003,
                description: 'Премьера "Призрак оперы" в России'
            },
            {
                year: 2004,
                description: 'Открытие театра "Сатирикон" в Москве'
            }
        ]
    },
    {
        period: [2006, 2014],
        section: 'Спорт',
        dates: [
            {
                year: 2006,
                description: 'Чемпионат мира по футболу в Германии'
            },
            {
                year: 2008,
                description: 'Олимпийские игры в Пекине'
            },
            {
                year: 2010,
                description: 'Чемпионат мира по футболу в ЮАР'
            },
            {
                year: 2012,
                description: 'Олимпийские игры в Лондоне'
            },
            {
                year: 2014,
                description: 'Зимние Олимпийские игры в Сочи'
            }
        ]
    },
    {
        period: [2015, 2022],
        section: 'Наука',
        dates: [
            {
                year: 2015,
                description: 'Открытие гравитационных волн'
            },
            {
                year: 2016,
                description: 'Обнаружение экзопланеты Проксима Центавра b'
            },
            {
                year: 2018,
                description: 'Запуск космического телескопа TESS'
            },
            {
                year: 2020,
                description: 'Создание вакцины от COVID-19'
            },
            {
                year: 2021,
                description: 'Первый полет вертолета на Марсе'
            },
            {
                year: 2022,
                description: 'Запуск космического телескопа詹姆斯 Уэбб'
            }
        ]
    }
]
